import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../services/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);
  const setShowAuthModal = useAuthStore((state) => state.setShowAuthModal);

  // Don't show auth modal while still loading
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gold-500"></div>
      </div>
    );
  }

  if (!user) {
    // Only show auth modal if we're not loading and there's no user
    setShowAuthModal(true);
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
